import { CrmConnectionProvider } from "@buzzeasy/crm-fragment";
import { PropsWithChildren, ReactElement, useContext } from "react";
import { useSelector } from "react-redux";
import environmentConfig from "../../environmentConfig";
import { selectAuthInfo } from "../../redux/authSlice";
import { SettingsContext } from "./SettingsContext";

const { apiBaseUrl } = environmentConfig;
const authCallbackUrl = `${window.location.protocol}//${window.location.host}/crm-auth/callback.html`;

/**
 * Serves as a wrapper for the CrmConnectionProvider.
 *
 * **Provider dependencies:**
 * - (Store) Provider
 * - SettingsProvider
 */
export default function CrmConnectionProviderWrapper({ children }: PropsWithChildren): ReactElement {
  const { token } = useSelector(selectAuthInfo);
  const [{ language }] = useContext(SettingsContext);

  return (
    <CrmConnectionProvider apiBaseUrl={apiBaseUrl} token={token} authCallbackUrl={authCallbackUrl} language={language}>
      {children}
    </CrmConnectionProvider>
  );
}
